import { Grid, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";

import { StyledLoginFormContainer } from "../styled-login-form-container";
import { PacknetLogo } from "../packnet-logo";
import type { LicenseTier } from "../../schemas";
import type { LicensedProductCategoryName } from "../../types";

const licenseNames: Record<LicensedProductCategoryName, string> = {
	Core: "PackNet Core",
	DIM: "PackNet Dimensioning",
	Reporting: "PackNet Reporting",
};

const licenseTiers: Record<LicenseTier, string> = {
	essential: "Essential",
	professional: "Professional",
	enterprise: "Enterprise",
	unlicensed: "Unlicensed",
	basic: "Basic",
};

export interface InsufficientLicenseProps {
	readonly product: LicensedProductCategoryName;
	readonly tier: LicenseTier;
}

export const InsufficientLicense: React.FC<InsufficientLicenseProps> = ({ product, tier }) => {
	return (
		<StyledLoginFormContainer maxWidth="sm" data-testid="insufficient-license">
			<Grid container direction="column" gap={6}>
				<PacknetLogo />

				<Grid container direction="column" gap={2}>
					<Typography fontWeight="bold">
						<FormattedMessage id="insufficient-license.header" defaultMessage="Insufficient License" />
					</Typography>
					<Typography>
						<FormattedMessage
							id="insufficient-license.subheader"
							defaultMessage="We're sorry, but you do not have the right license to access this page. Please contact your Packsize representative."
						/>
					</Typography>

					<Typography>
						<FormattedMessage
							id="insufficient-license.explanation"
							defaultMessage="To access this page you will need at least the {tierName} license for {productName}."
							values={{
								productName: (
									<Typography component="span" fontWeight="bold">
										{licenseNames[product]}
									</Typography>
								),
								tierName: (
									<Typography component="span" fontWeight="bold">
										{licenseTiers[tier]}
									</Typography>
								),
							}}
						/>
					</Typography>
				</Grid>
			</Grid>
		</StyledLoginFormContainer>
	);
};
